(function () {
  'use strict';

  class EbReviewWall extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rw-track]');
      this.dots = this.querySelector('[data-rw-dots]');

      this.bindPlay();
      this.buildDots();
    }

    bindPlay() {
      this.querySelectorAll('[data-rw-play]').forEach((btn) => {
        btn.addEventListener('click', () => this.play(btn));
      });
    }

    play(btn) {
      const card = btn.closest('[data-rw-video]');
      if (!card || card.dataset.rwPlaying === 'true') return;
      const id = card.getAttribute('data-rw-video');
      if (!id) return;

      card.dataset.rwPlaying = 'true';

      const host = document.createElement('div');
      host.className = 'eb-rw__iframe-host';

      const iframe = document.createElement('iframe');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', btn.getAttribute('aria-label') || this.getAttribute('data-rw-video-label') || '');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';

      host.appendChild(iframe);
      btn.replaceWith(host);
    }

    buildDots() {
      if (!this.dots || !this.track) return;
      const cards = [...this.track.children];
      if (cards.length < 2) return;

      cards.forEach((card, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'eb-rw__dot';
        const label = this.getAttribute('data-rw-dot-label') || '';
        dot.setAttribute('aria-label', label.replace('__INDEX__', i + 1));
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', () => {
          card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        this.dots.appendChild(dot);
      });

      const dotEls = [...this.dots.children];
      let raf = null;
      this.track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          const mid = this.track.scrollLeft + this.track.clientWidth / 2;
          let active = 0;
          cards.forEach((card, i) => {
            if (card.offsetLeft <= mid) active = i;
          });
          dotEls.forEach((d, i) => {
            if (i === active) d.setAttribute('aria-current', 'true');
            else d.removeAttribute('aria-current');
          });
        });
      }, { passive: true });
    }
  }

  if (!customElements.get('eb-review-wall')) {
    customElements.define('eb-review-wall', EbReviewWall);
  }
})();
